import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError, map } from 'rxjs/operators';
import { APICONSTANTS } from '../../constants/api-constants';
import { HostnameService } from '../basic/hostname.service';
import { ProjetSchemaDescrModel } from '../../models/simple-types/projet-models.model';
import { GenericCrudService } from '../basic/generic.crud.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SchemaForms } from '../../models/simple-types/projet-models.model';

@Injectable()

export class ProjetSchemaService extends GenericCrudService<ProjetSchemaDescrModel> {
  constructor(http: HttpClient, protected toastrService: ToastrService,
    protected hostnameService: HostnameService) {
    super(http, toastrService, APICONSTANTS.ROUTEPROJETSCHEMADESCR, hostnameService);
  }

  createForms(): Observable<SchemaForms> {
    return this.getAll().pipe(
      map((allSchemProj: ProjetSchemaDescrModel[]) => {
        const schemaForms = new SchemaForms();
        schemaForms.allProjetSchemaDescr = allSchemProj;
        schemaForms.allProjetAgenceForm = allSchemProj.map(() => new FormGroup({}));
        return (schemaForms);
      })
    );
  }

  //fake
  getAllDummies(): Observable<ProjetSchemaDescrModel[]> {

    var schema1: FormlyFieldConfig[] = [
      {
          key: "etatProjet",
          type: "select",
          props: {
              label: "Etat du projet",
              options: [
                  {
                      label: "Définition de la liste des agences",
                      value: "Définition de la liste des agences"
                  },
                  {
                      label: "Demande d'éligibilité",
                      value: "Demande d'éligibilité"
                  },
                  {
                      label: "Demande d'un bon de commande fournisseur",
                      value: "Demande d'un bon de commande fournisseur"
                  },
                  {
                      label: "Signature / BDC Sacha",
                      value: "Signature / BDC Sacha"
                  },
                  {
                      label: "Commande auprès du fournisseur en cours",
                      value: "Commande auprès du fournisseur en cours"
                  },
                  {
                      label: "Planification du déploiement de la ligne + migration",
                      value: "Planification du déploiement de la ligne + migration"
                  },
                  {
                      label: "Déploiement de la ligne + migration",
                      value: "Déploiement de la ligne + migration"
                  },
                  {
                      label: "Demande de résillation pour arrêt de facturation",
                      value: "Demande de résillation pour arrêt de facturation"
                  },
                  {
                      label: "Restitution des équipements",
                      value: "Restitution des équipements"
                  },
                  {
                      label: "Finalisé",
                      value: "Finalisé"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "champInformation",
          type: "textarea",
          props: {
              label: "Champ Information",
              autosize: true,
              disabled: true,
              required: true,
              maxLength: 250
          }
      },
      {
          key: "operateur1",
          type: "select",
          props: {
              label: "opérateur 1",
              options: [
                  {
                      label: "SFR",
                      value: "SFR"
                  },
                  {
                      label: "Bouygues",
                      value: "Bouygues"
                  },
                  {
                      label: "Orange",
                      value: "Orange"
                  },
                  {
                      label: "Coriolis",
                      value: "Coriolis"
                  },
                  {
                      label: "LinkT",
                      value: "LinkT"
                  },
                  {
                      label: "Starlink",
                      value: "Starlink"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "operateur2",
          type: "select",
          props: {
              label: "opérateur 2",
              options: [
                  {
                      label: "SFR",
                      value: "SFR"
                  },
                  {
                      label: "Bouygues",
                      value: "Bouygues"
                  },
                  {
                      label: "Orange",
                      value: "Orange"
                  },
                  {
                      label: "Coriolis",
                      value: "Coriolis"
                  },
                  {
                      label: "LinkT",
                      value: "LinkT"
                  },
                  {
                      label: "Starlink",
                      value: "Starlink"
                  }
              ],
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "operateur3",
          type: "select",
          props: {
              label: "opérateur 3",
              options: [
                  {
                      label: "SFR",
                      value: "SFR"
                  },
                  {
                      label: "Bouygues",
                      value: "Bouygues"
                  },
                  {
                      label: "Orange",
                      value: "Orange"
                  },
                  {
                      label: "Coriolis",
                      value: "Coriolis"
                  },
                  {
                      label: "LinkT",
                      value: "LinkT"
                  },
                  {
                      label: "Starlink",
                      value: "Starlink"
                  }
              ],
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "referenceOperateur1",
          type: "input",
          props: {
              label: "Référence opérateur 1",
              disabled: true,
              required: true,
              hideIfEmpty: true
          }
      },
      {
          key: "referenceOperateur2",
          type: "input",
          props: {
              label: "Référence opérateur 2",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "referenceOperateur3",
          type: "input",
          props: {
              label: "Référence opérateur 3",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "referenceMateriel1",
          type: "input",
          props: {
              label: "Référence matériel 1",
              disabled: true,
              required: true
          }
      },
      {
          key: "referenceMateriel2",
          type: "input",
          props: {
              label: "Référence matériel 2",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "referenceMateriel3",
          type: "input",
          props: {
              label: "Référence matériel 3",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "techDebit1",
          type: "select",
          props: {
              label: "Technologie 1 / débit",
              options: [
                  {
                      label: "FTTH",
                      value: "FTTH"
                  },
                  {
                      label: "FTTO 10Mo",
                      value: "FTTO 10Mo"
                  },
                  {
                      label: "FTTO 100Mo",
                      value: "FTTO 100Mo"
                  },
                  {
                      label: "4G",
                      value: "4G"
                  },
                  {
                      label: "5G",
                      value: "5G"
                  },
                  {
                      label: "Satellite",
                      value: "Satellite"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "techDebit2",
          type: "select",
          props: {
              label: "Technologie 2 / débit",
              options: [
                  {
                      label: "FTTH",
                      value: "FTTH"
                  },
                  {
                      label: "FTTO 10Mo",
                      value: "FTTO 10Mo"
                  },
                  {
                      label: "FTTO 100Mo",
                      value: "FTTO 100Mo"
                  },
                  {
                      label: "4G",
                      value: "4G"
                  },
                  {
                      label: "5G",
                      value: "5G"
                  },
                  {
                      label: "Satellite",
                      value: "Satellite"
                  }
              ],
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "techDebit3",
          type: "select",
          props: {
              label: "Technologie 3 / débit",
              options: [
                  {
                      label: "FTTH",
                      value: "FTTH"
                  },
                  {
                      label: "FTTO 10Mo",
                      value: "FTTO 10Mo"
                  },
                  {
                      label: "FTTO 100Mo",
                      value: "FTTO 100Mo"
                  },
                  {
                      label: "4G",
                      value: "4G"
                  },
                  {
                      label: "5G",
                      value: "5G"
                  },
                  {
                      label: "Satellite",
                      value: "Satellite"
                  }
              ],
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "cout1",
          type: "input",
          props: {
              type: "number",
              label: "Coût 1",
              disabled: true,
              required: true
          }
      },
      {
          key: "cout2",
          type: "input",
          props: {
              type: "number",
              label: "Coût 2",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "cout3",
          type: "input",
          props: {
              type: "number",
              label: "Coût 3",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "dateFinEngagement1",
          type: "input",
          props: {
              type: "date",
              label: "Date de fin d'engagement 1",
              disabled: true,
              required: true
          }
      },
      {
          key: "dateFinEngagement2",
          type: "input",
          props: {
              type: "date",
              label: "Date de fin d'engagement 2",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "dateFinEngagement3",
          type: "input",
          props: {
              type: "date",
              label: "Date de fin d'engagement 3",
              disabled: true,
              required: false,
              hideIfEmpty: true
          }
      },
      {
          key: "contactAgence",
          type: "input",
          props: {
              label: "Contacts sur l'agence",
              disabled: true,
              required: true
          }
      },
      {
          key: "natureAgence",
          type: "select",
          props: {
              label: "Nature de l'agence",
              options: [
                  {
                      label: "Dépot",
                      value: "Dépot"
                  },
                  {
                      label: "MVE",
                      value: "MVE"
                  },
                  {
                      label: "FTTO",
                      value: "FTTO"
                  },
                  {
                      label: "Chez le client",
                      value: "Chez le client"
                  },
                  {
                      label: "DR",
                      value: "DR"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "informationRestitution",
          type: "textarea",
          props: {
              label: "Information resitution",
              autosize: true,
              disabled: true,
              required: true,
              maxLength: 250
          }
      },
      {
          key: "dateArretFacturation",
          type: "input",
          props: {
              type: "date",
              label: "Date d'arrêt de la facturation",
              disabled: true,
              required: true
          }
      },
      {
          key: "dateRestitutionEquipement",
          type: "input",
          props: {
              type: "date",
              label: "Date de restitution des équipements",
              disabled: true,
              required: true
          }
      },
      {
          key: "listeEligibiliteFibre",
          type: "input",
          props: {
              label: "Liste d'éligbilité fibre",
              disabled: true,
              required: true
          }
      }
  ];

    var schema2: FormlyFieldConfig[] = [
      {
          key: "etatProjet",
          type: "select",
          props: {
              label: "Etat du projet",
              options: [
                  {
                      label: "Définition de la liste des agences",
                      value: "Définition de la liste des agences"
                  },
                  {
                      label: "Demande d'un devis fournisseur pour audit",
                      value: "Demande d'un devis fournisseur pour audit"
                  },
                  {
                      label: "Validation du devis par l'agence, fourniture d'un BDC",
                      value: "Validation du devis par l'agence, fourniture d'un BDC"
                  },
                  {
                      label: "Planification de l'audit",
                      value: "Planification de l'audit"
                  },
                  {
                      label: "Demande d'un devis fournisseur pour les travaux",
                      value: "Demande d'un devis fournisseur pour les travaux"
                  },
                  {
                      label: "Validation du devis par l'agence, fourniture d'un BDC",
                      value: "Validation du devis par l'agence, fourniture d'un BDC"
                  },
                  {
                      label: "Planification des travaux",
                      value: "Planification des travaux"
                  },
                  {
                      label: "Finalisé",
                      value: "Finalisé"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "dateAudit",
          type: "input",
          props: {
              type: "date",
              label: "Date audit",
              disabled: true,
              required: true
          }
      },
      {
          key: "coutAudit",
          type: "input",
          props: {
              type: "number",
              label: "Coût audit",
              disabled: true,
              required: true
          }
      },
      {
          key: "dateTravaux",
          type: "input",
          props: {
              type: "date",
              label: "Date des travaux",
              disabled: true,
              required: true
          }
      },
      {
          key: "coutTravaux",
          type: "input",
          props: {
              type: "number",
              label: "Coût des travaux",
              disabled: true,
              required: true
          }
      },
      {
          key: "scopeTravaux1",
          type: "checkbox",
          props: {
              label: "Scope des travaux : Baie",
              disabled: true,
              required: true
          },
          defaultValue: false
      },
      {
          key: "scopeTravaux2",
          type: "checkbox",
          props: {
              label: "Scope des travaux : prise murale",
              disabled: true,
              required: true
          },
          defaultValue: false
      },
      {
          key: "scopeTravaux3",
          type: "checkbox",
          props: {
              label: "Scope des travaux : brassage de la baie",
              disabled: true,
              required: true
          },
          defaultValue: false
      }
  ];

    var schema3: FormlyFieldConfig[] = [
      {
          key: "etatProjet",
          type: "select",
          props: {
              label: "Etat du projet",
              options: [
                  {
                      label: "Définition de la liste des agences",
                      value: "1"
                  },
                  {
                      label: "Récupération des prérequis en cours",
                      value: "Récupération des prérequis en cours"
                  },
                  {
                      label: "Demande de portabilité et planification auprès de Ring Central en cours",
                      value: "Demande de portabilité et planification auprès de Ring Central en cours"
                  },
                  {
                      label: "Planification de la portabilité",
                      value: "Planification de la portabilité"
                  },
                  {
                      label: "Planification de de l'installation et formation par Convergence",
                      value: "Planification de de l'installation et formation par Convergence"
                  },
                  {
                      label: "Déploiement / Portabilité",
                      value: "Déploiement / Portabilité"
                  },
                  {
                      label: "Facturation",
                      value: "Facturation"
                  },
                  {
                      label: "Finalisé",
                      value: "Finalisé"
                  }
              ]
          }
      },
      {
          key: "champInformation",
          type: "textarea",
          props: {
              label: "Champ information",
              autosize: true,
              disabled: true,
              required: true,
              maxLength: 250
          }
      },
      {
          key: "prerequis1",
          type: "checkbox",
          props: {
              label: "Prérequis : Liste des utilisateurs avec numéro",
              disabled: true,
              required: true
          },
          defaultValue: false
      },
      {
          key: "prerequis2",
          type: "checkbox",
          props: {
              label: "Prérequis : Architecture des appels (fonctionnement du standard et renvois)",
              disabled: true,
              required: true
          },
          defaultValue: false
      },
      {
          key: "prerequis3",
          type: "checkbox",
          props: {
              label: "Prérequis : Factures opérateurs de moins de 3 mois",
              disabled: true,
              required: true
          },
          defaultValue: false
      },
      {
          key: "prerequis4",
          type: "checkbox",
          props: {
              label: "Prérequis : Mandats de portabilité signé",
              disabled: true,
              required: true
          },
          defaultValue: false
      },
      {
          key: "referenceRCPortabilite",
          type: "input",
          props: {
              label: "Référence RC de portabilité",
              disabled: true,
              required: true
          }
      },
      {
          key: "dateEstimePlanif",
          type: "input",
          props: {
              type: "date",
              label: "Date estimé de planification",
              disabled: true,
              required: true
          }
      },
      {
          key: "dateReceptionTel",
          type: "input",
          props: {
              type: "date",
              label: "Date de réception des téléphones",
              disabled: true,
              required: true
          }
      },
      {
          key: "dateInstallationTel",
          type: "input",
          props: {
              type: "date",
              label: "Date dinstallation des téléphones",
              disabled: true,
              required: true
          }
      },
      {
          key: "datePortabilite",
          type: "input",
          props: {
              type: "date",
              label: "Date de portabilité",
              disabled: true,
              required: true
          }
      },
      {
          key: "telNumSerie",
          type: "input",
          props: {
              label: "téléphone Numéro de série",
              disabled: true,
              required: true
          }
      },
      {
          key: "telModele",
          type: "select",
          props: {
              label: "Téléphone modele",
              options: [
                  {
                      label: "POLY EDGE 350",
                      value: "POLY EDGE 350"
                  },
                  {
                      label: "POLY EDGE 450",
                      value: "POLY EDGE 450"
                  },
                  {
                      label: "DECT",
                      value: "DECT"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "telMarque",
          type: "select",
          props: {
              label: "téléphone marque",
              options: [
                  {
                      label: "CISCO",
                      value: "CISCO"
                  },
                  {
                      label: "PolyEdge",
                      value: "PolyEdge"
                  },
                  {
                      label: "Poly VVX",
                      value: "Poly VVX"
                  }
              ],
              disabled: true,
              required: true
          }
      },
      {
          key: "nbLigneDigit",
          type: "input",
          props: {
              type: "number",
              label: "Nbre de ligne digitale",
              disabled: true,
              required: true
          }
      },
      {
          key: "nbLigneVirtuelle",
          type: "input",
          props: {
              type: "number",
              label: "Nbre de ligne virtuelle",
              disabled: true,
              required: true
          }
      },
      {
          key: "nbsoftPhone",
          type: "input",
          props: {
              type: "number",
              label: "Nbre de soft phone",
              disabled: true,
              required: true
          }
      },
      {
          key: "nbTel",
          type: "input",
          props: {
              type: "number",
              label: "Nbre de téléphone",
              disabled: true,
              required: true
          }
      }
  ];

    var schema4: FormlyFieldConfig[] =  [
      {
        key: 'scopeIPLan',
        type: 'input',
        props: {
          label: 'Scope IP lan',
          required: true,
          disabled: true
        }
      },
      {
        key: 'IPLanInterfaceBarracuda',
        type: 'input',
        props: {
          label: 'Ip Lan interface Barracuda',
          required: true,
          disabled: true
        }
      },
      {
        key: 'scopeIPPublique1',
        type: 'input',
        props: {
          label: 'Scope IP publique 1',
          required: true,
          disabled: true
        }
      },
      {
        key: 'scopeIPPublique2',
        type: 'input',
        props: {
          label: 'Scope IP publique 2',
          required: true,
          disabled: true
        }
      },
      {
        key: 'scopeIPPublique3',
        type: 'input',
        props: {
          label: 'Scope IP publique 3',
          required: true,
          disabled: true
        }
      },
      {
        key: 'latitude',
        type: 'input',
        props: {
          label: 'Latitude',
          required: true,
          disabled: true
        }
      },
      {
        key: 'longitude',
        type: 'input',
        props: {
          label: 'Longitude',
          required: true,
          disabled: true
        }
      },
      {
        key: 'numSerieBoitierSDWAN',
        type: 'input',
        props: {
          label: 'Numéro de série du boitier SD-WAN',
          required: true,
          disabled: true
        }
      },
      {
        key: 'marqueBoitierSDWAN',
        type: 'select',
        props: {
          label: 'Marque du boitier SD-WAN',
          options: [
            { 
                label: 'Barracuda', 
                value: 'Barracuda' },
            { 
                label: 'Palo Alto', 
                value: 'Palo Alto'
            },
          ],
          required: true,
          disabled: true
        }
      },
      {
        key: 'switchNom',
        type: 'input',
        props: {
          label: 'Switch nom',
          required: true,
          disabled: true
        }
      },
      {
        key: 'switchAdresseMac',
        type: 'input',
        props: {
          label: 'Switch adresse MAC',
          required: true,
          disabled: true
        }
      },
      {
        key: 'nbPorts',
        type: 'select',
        props: {
          label: 'Nbre de ports',
          options: [
            { label: '8', value: '8' },
            { label: '16', value: '16' },
            { label: '24', value: '24' },
            { label: '48', value: '48' },
          ],
          required: true,
          disabled: true
        }
      },
      {
        key: 'switchIP',
        type: 'input',
        props: {
          label: 'Switch IP',
          required: true,
          disabled: true
        }
      },
      {
        key: 'dateRecharge4g',
        type: 'input',
        props: {
          label: 'Recharge routeur 4G',
          type: 'date',
          required: true,
          disabled: true
        }
      },
    ];

    var schema5: FormlyFieldConfig[] =  [
        {
          key: 'Marque',
          type: 'select',
          props: {
            label: 'Marque',
            options: [
                { 
                  label: 'Lexmark', 
                  value: 'Lexmark' 
                },
                { 
                  label: 'Konica Minolta', 
                  value: 'Konica Minolta'
                },
                { 
                    label: 'HP', 
                    value: 'HP'
                },
                { 
                    label: 'Kyocera', 
                    value: 'Kyocera'
                },
                { 
                    label: 'Canon', 
                    value: 'Canon'
                },
            ],
            disabled: true,
            hideIfEmpty: true
          }
        },
        {
            key: 'Modèle',
            type: 'select',
            props: {
              label: 'Modèle',
              options: [
                { 
                    label: 'CX921de', 
                    value: 'CX921de' 
                  },
                  { 
                    label: 'CX725de', 
                    value: 'CX725de'
                  },
                  { 
                    label: 'CX735adse', 
                    value: 'CX735adse'
                  },
                  { 
                    label: 'CX931dse', 
                    value: 'CX931dse'
                  },
                  { 
                    label: 'C368', 
                    value: 'C368'
                  },
                  { 
                    label: 'MX722adhe', 
                    value: 'MX722adhe'
                  },
                  { 
                    label: 'CX922de', 
                    value: 'CX922de'
                  },
                  { 
                    label: 'C300i', 
                    value: 'C300i'
                  },
                  { 
                    label: 'CX921de C450i', 
                    value: 'CX921de C450i'
                  },
                  { 
                    label: 'C458', 
                    value: 'C458'
                  },
                  { 
                    label: 'CX924de', 
                    value: 'CX924de'
                  },
                  { 
                    label: 'CX735', 
                    value: 'CX735'
                  },
                  { 
                    label: 'C360i', 
                    value: 'C360i'
                  },
                  { 
                    label: 'LaserJet P2055dn', 
                    value: 'LaserJet P2055dn'
                  },
                  { 
                    label: 'C258', 
                    value: 'C258'
                  },
                  { 
                    label: 'C224e', 
                    value: 'C224e'
                  },
                  { 
                    label: 'C250i', 
                    value: 'C250i'
                  },
                  { 
                    label: 'MS825dn', 
                    value: 'MS825dn'
                  },
                  { 
                    label: 'C3350i', 
                    value: 'C3350i'
                  },
                  { 
                    label: 'MX522adhe', 
                    value: 'MX522adhe'
                  },
                  { 
                    label: 'C308', 
                    value: 'C308'
                  },
                  { 
                    label: 'C4050i', 
                    value: 'C4050i'
                  },
                  { 
                    label: 'Color LaserJet MFP M281fdw', 
                    value: 'Color LaserJet MFP M281fdw'
                  },
                  { 
                    label: 'CX942', 
                    value: 'CX942'
                  },
                  { 
                    label: 'CX625', 
                    value: 'CX625'
                  },
                  { 
                    label: 'TASKalfa 4052ci', 
                    value: 'TASKalfa 4052ci'
                  },
                  { 
                    label: 'OfficeJet Pro 8210', 
                    value: 'OfficeJet Pro 8210'
                  },
                  { 
                    label: 'G5000', 
                    value: 'G5000'
                  },
                  { 
                    label: 'CX962se', 
                    value: 'CX962se'
                  },
                  { 
                    label: 'OfficeJetPro 8720', 
                    value: 'OfficeJetPro 8720'
                  },
                  { 
                    label: 'OKI-MC853-0202E7', 
                    value: 'OKI-MC853-0202E7'
                  },
                  { 
                    label: 'C3350', 
                    value: 'C3350'
                  },
                  { 
                    label: 'C284e', 
                    value: 'C284e'
                  },
                  { 
                    label: 'C258e', 
                    value: 'C258e'
                  },
                  { 
                    label: 'LaserJet M402dne', 
                    value: 'LaserJet M402dne'
                  },
                  { 
                    label: 'LaserJet Imprim. P3015', 
                    value: 'LaserJet Imprim. P3015'
                  },
                  { 
                    label: 'Color LaserJet M452nw', 
                    value: 'Color LaserJet M452nw'
                  },
                  { 
                    label: 'LaserJet Pro M404dn', 
                    value: 'LaserJet Pro M404dn'
                  },
                  { 
                    label: 'LaserJet 500 color M551', 
                    value: 'LaserJet 500 color M551'
                  },
                  { 
                    label: 'HL-L2360D', 
                    value: 'HL-L2360D'
                  },
                  { 
                    label: 'C3351', 
                    value: 'C3351'
                  },
                  { 
                    label: 'Color LaserJet M553', 
                    value: 'Color LaserJet M553'
                  },
                  { 
                    label: 'CS622de', 
                    value: 'CS622de'
                  },
                  { 
                    label: 'bizhub 3301P', 
                    value: 'bizhub 3301P'
                  },
                  { 
                    label: 'Matricielle', 
                    value: 'Matricielle'
                  },
                  { 
                    label: 'C650i', 
                    value: 'C650i'
                  },
                  { 
                    label: 'C558', 
                    value: 'C558'
                  },
                  { 
                    label: 'CX944adxse', 
                    value: 'CX944adxse'
                  },
                  { 
                    label: 'LaserJet Pro M201n', 
                    value: 'LaserJet Pro M201n'
                  },
                  { 
                    label: 'Bizhub283', 
                    value: 'Bizhub283'
                  },
                  { 
                    label: 'CX942adse', 
                    value: 'CX942adse'
                  },
                  { 
                    label: 'C364e', 
                    value: 'C364e'
                  },
                  { 
                    label: 'DesignJet T1700', 
                    value: 'DesignJet T1700'
                  },
                  { 
                    label: 'OfficeJet Pro 9020 series', 
                    value: 'OfficeJet Pro 9020 series'
                  },
                  { 
                    label: 'LaserJet 400 color M451dn', 
                    value: 'LaserJet 400 color M451dn'
                  },
                  { 
                    label: 'C3320i', 
                    value: 'C3320i'
                  },
                  { 
                    label: 'LaserJet 400 M401dn', 
                    value: 'LaserJet 400 M401dn'
                  },
                  { 
                    label: 'CX825', 
                    value: 'CX825'
                  },
                  { 
                    label: 'LaserJet M406', 
                    value: 'LaserJet M406'
                  },
                  { 
                    label: 'LaserJet MFP M426fdw', 
                    value: 'LaserJet MFP M426fdw'
                  },
                  { 
                    label: 'M479 Dw', 
                    value: 'M479 Dw'
                  },
                  { 
                    label: 'LaserJet M506', 
                    value: 'LaserJet M506'
                  },
                  { 
                    label: 'LaserJet Pro MFP M428fdw', 
                    value: 'LaserJet Pro MFP M428fdw'
                  },
                  { 
                    label: 'DCP-L8410CDW', 
                    value: 'DCP-L8410CDW'
                  },
                  { 
                    label: 'CX944', 
                    value: 'CX944'
                  },
                  { 
                    label: 'C350i', 
                    value: 'C350i'
                  },
                  { 
                    label: 'Color LaserJet 400 M401dn', 
                    value: 'Color LaserJet 400 M401dn'
                  },
                  { 
                    label: 'CX961se', 
                    value: 'CX961se'
                  },
                  { 
                    label: 'C950', 
                    value: 'C950'
                  },
                  { 
                    label: 'Color LaserJet M452dn', 
                    value: 'Color LaserJet M452dn'
                  },
                  { 
                    label: 'CX625adhe', 
                    value: 'CX625adhe'
                  },
                  { 
                    label: 'HP Color LaserJet MFP M476dw', 
                    value: 'HP Color LaserJet MFP M476dw'
                  },
                  { 
                    label: 'CX931dse LaserJet M203dw', 
                    value: 'CX931dse LaserJet M203dw'
                  },
                  { 
                    label: 'Office Jet Pro 9020 Series', 
                    value: 'Office Jet Pro 9020 Series'
                  },
                  { 
                    label: 'HL - 4570CDW', 
                    value: 'HL - 4570CDW'
                  },
                  { 
                    label: 'CX635ade', 
                    value: 'CX635ade'
                  },
                  { 
                    label: 'LaserJet Pro MFP M428fdn', 
                    value: 'LaserJet Pro MFP M428fdn'
                  },
                  { 
                    label: 'C250', 
                    value: 'C250'
                  }
              ],
              disabled: true,
              hideIfEmpty: true
            }
          },
        {
          key: 'IP',
          type: 'input',
          props: {
            label: 'IP',
            disabled: true,
            hideIfEmpty: true,
            maxLength: 255
          }
        },
        {
            key: 'Serial number',
            type: 'input',
            props: {
              label: 'Serial number',
              disabled: true,
              hideIfEmpty: true,
              maxLength: 255
            }
        },
        {
            key: 'MAC',
            type: 'input',
            props: {
              label: 'MAC',
              disabled: true,
              hideIfEmpty: true,
              maxLength: 255
            }
        },
        {
            key: 'date de fin de contrat',
            type: 'input',
            props: {
              label: 'date de fin de contrat',
              type: 'date',
              disabled: true,
              hideIfEmpty: true
            }
        },
        {
            key: 'date d\'installation',
            type: 'input',
            props: {
              label: 'date d\'installation',
              type: 'date',
              disabled: true,
              hideIfEmpty: true
            }
        },
        {
            key: 'date de désintallation/durée de facturation',
            type: 'input',
            props: {
              label: 'date de désintallation/durée de facturation',
              type: 'date',
              disabled: true,
              hideIfEmpty: true
            }
        },
        {
            key: 'Contact consommable',
            type: 'input',
            props: {
              label: 'Contact consommable',
              disabled: true,
              hideIfEmpty: true,
              maxLength: 255
            }
        },
        {
            key: 'Tel',
            type: 'input',
            props: {
              label: 'Tel',
              disabled: true,
              hideIfEmpty: true,
              maxLength: 255
            }
        },
        {
            key: 'Adresse mail',
            type: 'input',
            props: {
              label: 'Adresse mail',
              disabled: true,
              hideIfEmpty: true,
              maxLength: 255
            }
        },
        {
            key: 'Installé sur Gestami',
            type: 'checkbox',
            props: {
              label: 'Installé sur Gestami',
              disabled: true,
              hideIfEmpty: true
            },
            defaultValue: false
        },
      ];

    var projetSchemaDescr1: ProjetSchemaDescrModel = new ProjetSchemaDescrModel();
    projetSchemaDescr1.id = 1;
    projetSchemaDescr1.libelle = "PTHD";
    projetSchemaDescr1.code = "PTHD";
    projetSchemaDescr1.mailModifieurs = JSON.stringify(["vincent.kim@veolia.com", "lu.tian@veolia.com"]);
    console.log(projetSchemaDescr1.mailModifieurs)
    projetSchemaDescr1.schema = JSON.stringify(schema1);

    var projetSchemaDescr2: ProjetSchemaDescrModel = new ProjetSchemaDescrModel();
    projetSchemaDescr2.id = 2;
    projetSchemaDescr2.libelle = "Refonte Lan";
    projetSchemaDescr2.code = "Refonte Lan";
    projetSchemaDescr2.mailModifieurs = JSON.stringify(["vincent.kim@veolia.com"]);
    projetSchemaDescr2.schema = JSON.stringify(schema2);

    var projetSchemaDescr3: ProjetSchemaDescrModel = new ProjetSchemaDescrModel();
    projetSchemaDescr3.id = 7;
    projetSchemaDescr3.libelle = "Ring Central";
    projetSchemaDescr3.code = "Ring Central";
    projetSchemaDescr3.mailModifieurs = JSON.stringify(["vincent.kim@veolia.com"]);
    projetSchemaDescr3.schema = JSON.stringify(schema3);

    var projetSchemaDescr4: ProjetSchemaDescrModel = new ProjetSchemaDescrModel();
    projetSchemaDescr4.id = 8;
    projetSchemaDescr4.libelle = "MCO";
    projetSchemaDescr4.code = "MCO";
    projetSchemaDescr4.mailModifieurs = JSON.stringify(["vincent.kim@veolia.com"]);
    projetSchemaDescr4.schema = JSON.stringify(schema4);

    var projetSchemaDescr5: ProjetSchemaDescrModel = new ProjetSchemaDescrModel();
    projetSchemaDescr5.id = 100;
    projetSchemaDescr5.libelle = "Imprimante";
    projetSchemaDescr5.code = "Imprimante";
    projetSchemaDescr5.mailModifieurs = JSON.stringify(["vincent.kim@veolia.com"]);
    projetSchemaDescr5.schema = JSON.stringify(schema5);
    
    console.log(projetSchemaDescr1.schema)
    console.log(projetSchemaDescr2.schema)
    console.log(projetSchemaDescr3.schema)
    console.log(projetSchemaDescr4.schema)
    console.log(projetSchemaDescr5.schema)
    

    var prjSchemas: ProjetSchemaDescrModel[] = [
      projetSchemaDescr1, 
      projetSchemaDescr2,
      projetSchemaDescr3,
      projetSchemaDescr4,
      projetSchemaDescr5
    ];

    return of(prjSchemas);
  }
  //end fake

  private sanitizeSchema(model: ProjetSchemaDescrModel): ProjetSchemaDescrModel {
    if (model.schema) {
        let schemaObj = JSON.parse(model.schema);
        this.removeExpressions(schemaObj);
        model.schema = JSON.stringify(schemaObj);
    }
    return model;
  }

  private removeExpressions(obj: any) {
      for (let key in obj) {
          if (key === 'expressions') {
              delete obj[key];
          } else if (typeof obj[key] === 'object') {
              this.removeExpressions(obj[key]);
          }
      }
  }

  get(id: number): Observable<ProjetSchemaDescrModel> {
      return this.http.get<ProjetSchemaDescrModel>(APICONSTANTS.URLAPI.value + this.route + 'Get/' + id)
          .pipe(
              map(model => this.sanitizeSchema(model)),
              catchError(err => this.requestCatchError(err, 'get'))
          );
  }

  getAll(): Observable<ProjetSchemaDescrModel[]> {
      return this.http.get<ProjetSchemaDescrModel[]>(APICONSTANTS.URLAPI.value + this.route + 'GetAll/')
          .pipe(
              map(models => models.map(model => this.sanitizeSchema(model))),
              catchError(err => this.requestCatchError(err, 'GetAll'))
          );
  }

  getAllForFiltre(): Observable<ProjetSchemaDescrModel[]> {
      return this.http.get<ProjetSchemaDescrModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllForFiltre/')
          .pipe(
              map(models => models.map(model => this.sanitizeSchema(model))),
              catchError(err => this.requestCatchError(err, 'getAllForFiltre'))
          );
  }

  getAllbyId(request: string, id: number): Observable<ProjetSchemaDescrModel[]> {
      return this.http.get<ProjetSchemaDescrModel[]>(APICONSTANTS.URLAPI.value + this.route + request + id)
          .pipe(
              map(models => models.map(model => this.sanitizeSchema(model))),
              catchError(err => this.requestCatchError(err, 'Le chargement'))
          );
  }

  getAllFromObjet(request: string, objet: any): Observable<ProjetSchemaDescrModel[]> {
      return this.http.post<ProjetSchemaDescrModel[]>(APICONSTANTS.URLAPI.value + this.route + request, objet)
          .pipe(
              map(models => models.map(model => this.sanitizeSchema(model))),
              catchError(err => this.requestCatchError(err, 'Le chargement'))
          );
  }

  requestCatchError(error, origineError): Observable<any> {
    let errorMessage = '';
    if (error.status === 400) {
      this.toastrService.error(error.error, 'Erreur client');
      errorMessage = `Error: ${error.error.message}`;
      return throwError(errorMessage);
    }
    if (error.error instanceof ErrorEvent) {
        // client-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur client');
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        this.toastrService.error(origineError + '  a échoué.', 'Erreur serveur');
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}